export const projects = [
  {
    id: 1,
    title: "Риэлторский сайт",
    type: "commercial",
    stack: ["HTML", "CSS", "JS", "Яндекс.Карты"],
    description:
      "Многостраничный сайт для риэлторской компании с каталогом объектов, галереями и формой обратной связи.",
    demo: "https://lesanepc.github.io/altair-projects/",
    code: "https://github.com/LesanePC/altair-projects"
  },
  {
    id: 2,
    title: "Сайт строительной компании",
    type: "commercial",
    stack: ["HTML", "CSS", "JS"],
    description:
      "Сайт-визитка строительной компании с адаптивной версткой, галереей проектов и формой заявки.",
    demo: "https://lesanepc.github.io/Rem-Stroy/index.html",
    code: "https://github.com/LesanePC/Rem-Stroy"
  },
  {
    id: 3,
    title: "Кинотеатр (SPA)",
    type: "study",
    stack: ["JS", "Vite", "API"],
    description:
      "Интерактивный киносайт с получением данных по API, списком фильмов и бронированием мест.",
    demo: "https://lesanepc.github.io/shfe-diplom/index.html",
    code: "https://github.com/LesanePC/shfe-diplom"
  },
  {
    id: 4,
    title: "Тест / Калькулятор / ToDo",
    type: "study",
    stack: ["HTML", "CSS", "JS"],
    description:
      "Набор учебных проектов: тест с таймером, калькулятор и todo-лист для демонстрации работы с DOM и логикой.",
    demo: "https://lesanepc.github.io/MyCalculator/",
    code: "https://github.com/LesanePC/MyCalculator"
  }
];
